import styled from 'styled-components';

export const Wrapper = styled.div`
  max-width: 500px;
  padding: 20px;
  border: 1px solid grey;
  box-shadow: 0 0 8px black;
  margin: 0 auto;
  margin-top: 100px;
`;

export const InputWrapper = styled.div`
  margin-bottom: 20px;
`;

export const InputUpperWrapper = styled.div`
  display: flex !important;
  flex-direction: column !important;
`;

export const Title = styled.span`
  font-size: 26px;

  &:before {
    font-family: 'telusdings';
    padding-right: 10px; 
    content: "\\E057";
  }
`;
